export interface UIPermissions {
  read: string
  write: string
}
